import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Paper, Button, makeStyles, Popover } from "@material-ui/core";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import CloseIcon from "@material-ui/icons/Close";
import BarChart from "@material-ui/icons/BarChart";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import FormatIndentIncreaseIcon from "@material-ui/icons/FormatIndentIncrease";
import EventNoteIcon from "@material-ui/icons/EventNote";
import { orange, red } from "@material-ui/core/colors";
import CloseSaleIcon from "@material-ui/icons/BlockRounded";
import MassClossingIcon from "@material-ui/icons/LocationDisabled";
import UploadButton from "../../UploadButton/UploadButton.jsx";
import TrackChanges from "@material-ui/icons/TrackChanges";
import { ButtonFilterTarif } from "./ButtonFilterTarif.jsx";

const useStyles = makeStyles((palette) => ({
    root: {
        backgroundColor: palette.palette.background.paper,
        position: "fixed",
        // left: "48%", old
        left: "25%",
        top: "12%",
        zIndex: 2,
        padding: ".25rem 1rem .4rem 1rem",
    },
    middleBtn: {
        marginRight: ".5rem",
        marginLeft: ".5rem",
    },
    lastBtn: {
        marginLeft: ".5rem",
    },
    openRuleModuleBtn: {
        marginRight: ".9rem",
        backgroundColor: orange[500],

        "&:hover": {
            backgroundColor: orange[700],
        },
    },
    openMassClossingBtn: {
        marginRight: ".9rem",
        backgroundColor: red[500],

        "&:hover": {
            backgroundColor: red[700],
        },
    },
    vectorCloseButton: {
        fontWeight: "bold",
    },
}));

const Toolbar = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    return ReactDOM.createPortal(
        <Paper className={classes.root}>
            {/*<Button*/}
            {/*    className={classes.openMassClossingBtn}*/}
            {/*    variant="contained"*/}
            {/*    color="secondary"*/}
            {/*    title="Открыть массовое редактирование активности цен"*/}
            {/*    onClick={() => props.openMassClossing(true)}*/}
            {/*>*/}
            {/*    <MassClossingIcon />*/}
            {/*</Button>*/}

            <Button
                variant="contained"
                color="secondary"
                data-id="p"
                disabled={!props?.toolbarIsOpen}
                style={
                    props?.toolbarIsOpen !== true
                        ? { backgroundColor: "#a9a9a9" }
                        : {}
                }
                className={classes.middleBtn + " " + classes.openRuleModuleBtn}
                title={`Закрыть по параметрам выбранных тарифов и категорий`}
                onClick={handlePopoverOpen}
            >
                <span className={classes.vectorCloseButton}>ЗП</span>
            </Button>

            <Button
                variant="contained"
                color="secondary"
                data-id="cr"
                disabled={!props?.toolbarIsOpen}
                style={
                    props?.toolbarIsOpen !== true
                        ? { backgroundColor: "#a9a9a9" }
                        : {}
                }
                className={classes.middleBtn + " " + classes.openRuleModuleBtn}
                title={`Закрыть продажи выбранной категории номера ${props?.roomTypeName} \n в текущем тарифе ${props?.rateName} `}
                onClick={handlePopoverOpen}
            >
                <span className={classes.vectorCloseButton}>КТ</span>
            </Button>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <div>
                    <Button
                        onClick={() => {
                            props.handleClosedVector(
                                anchorEl.getAttribute("data-id"),
                                "close",
                            );
                            handlePopoverClose();
                        }}
                    >
                        Закрыть
                    </Button>
                    <Button
                        onClick={() => {
                            props.handleClosedVector(
                                anchorEl.getAttribute("data-id"),
                                "open",
                            );
                            handlePopoverClose();
                        }}
                    >
                        Открыть
                    </Button>
                </div>
            </Popover>
            <Button
                variant="contained"
                disabled={!props?.toolbarIsOpen}
                style={
                    props?.toolbarIsOpen !== true
                        ? { backgroundColor: "#a9a9a9" }
                        : {}
                }
                color="primary"
                data-id="c"
                className={
                    classes.middleBtn + " " + classes.openMassClossingBtn
                }
                title={`Закрыть продажу всех категорий номера в выбранном тарифе ${props?.rateName}`}
                onClick={handlePopoverOpen}
            >
                <span className={classes.vectorCloseButton}>T</span>
            </Button>
            <Button
                variant="contained"
                color="primary"
                disabled={!props?.toolbarIsOpen}
                style={
                    props?.toolbarIsOpen !== true
                        ? { backgroundColor: "#a9a9a9" }
                        : {}
                }
                data-id="r"
                className={
                    classes.middleBtn + " " + classes.openMassClossingBtn
                }
                title={`Закрыть продажи категории номера ${props?.roomTypeName} во всех тарифах`}
                onClick={handlePopoverOpen}
            >
                <span className={classes.vectorCloseButton}>K</span>
            </Button>

            <Button
                className={classes.openRuleModuleBtn}
                style={{ display: "none" }}
                variant="contained"
                color="secondary"
                title="Открыть форму изменения тарифа по параметрам"
                onClick={() => props.openByRulesModule(true)}
            >
                <EventNoteIcon />
            </Button>
            <Button
                variant="contained"
                style={{ display: "none" }}
                color="primary"
                title="Копировать стоимость проживания"
                onClick={props.copyCellValue}
                disabled={!props.copyIsEnabled || props.noSelectedCells}
            >
                <FilterNoneIcon />
            </Button>
            <Button
                variant="contained"
                style={{ display: "none" }}
                color="primary"
                title="Вставить скопированное значение"
                className={classes.middleBtn}
                onClick={props.pasteCopiedCellValue}
                disabled={!props.pasteIsEnabled || props.noSelectedCells}
            >
                <FormatIndentIncreaseIcon />
            </Button>
            {/*<Button*/}
            {/*    variant="contained"*/}
            {/*    color="primary"*/}
            {/*    className={classes.middleBtn}*/}
            {/*    title="Закрыть/открыть для продаж"*/}
            {/*    onClick={props.closeSaleHandler}*/}
            {/*    disabled={props.noSelectedCells}*/}
            {/*>*/}
            {/*    <CloseSaleIcon />*/}
            {/*</Button>*/}
            <Button
                variant="contained"
                color="primary"
                className={classes.middleBtn}
                style={{ display: "none" }}
                title="Редактировать стоимость проживания"
                onClick={props.updateFormOpen}
                disabled={props.noSelectedCells}
            >
                <BorderColorIcon />
            </Button>
            <UploadButton
                hotelId={+props.hotelId}
                toolbarIsOpen={props?.toolbarIsOpen}
                className={classes.middleBtn}
                setModalInheritActive={props.setModalInheritActive}
                setNeedSavedBanned={props.setNeedSavedBanned}
                setFromUploadPrices={props.setFromUploadPrices}
            />
            {import.meta.env.VITE_API_NEW_PRICE_LOADER === "true" && (
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.middleBtn}
                    title="Статус загрузки прайса"
                    onClick={props.handleStatusUpload}
                >
                    <TrackChanges />
                </Button>
            )}
            <Button
                variant="contained"
                color="primary"
                className={classes.middleBtn}
                title="Автонаследование тарифов"
                onClick={() => props.setModalInheritActive(true)}
            >
                <BarChart />
            </Button>

            <Button
                variant="contained"
                color="secondary"
                className={classes.lastBtn}
                title="Отменить выделение и убрать меню"
                onClick={props.removeToolbar}
            >
                <CloseIcon />
            </Button>
            <ButtonFilterTarif
                setStatusActualRatesFilter={props.setStatusActualRatesFilter}
                statusActualRatesFilter={props.statusActualRatesFilter}
                filterTarif={classes.lastBtn}
            />
        </Paper>,
        document.getElementById("toolbar"),
    );
};

export default Toolbar;
